import { render, staticRenderFns } from "./BankPixType.vue?vue&type=template&id=3575257c"
import script from "./BankPixType.vue?vue&type=script&lang=js"
export * from "./BankPixType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3575257c')) {
      api.createRecord('3575257c', component.options)
    } else {
      api.reload('3575257c', component.options)
    }
    module.hot.accept("./BankPixType.vue?vue&type=template&id=3575257c", function () {
      api.rerender('3575257c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/BankPixType.vue"
export default component.exports